import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'ebeihilfe-error-svg',
  templateUrl: './error-svg.component.svg',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
})
export class ErrorSvgComponent {}
